import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatDialogModule,
  MatSlideToggleModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
} from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ErrorInterceptor } from "src/_helpers/error.interceptor";
import { HttpRequestInterceptor } from "src/_helpers/http-request.interceptor";
import { JwtInterceptor } from "src/_helpers/jwt.interceptor";
import { MatNativeDateModule } from "@angular/material/core";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgApexchartsModule } from "ng-apexcharts";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AngularMaterialModule } from "./angular-material.module";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SportManagementComponent } from "./pages/sport-management/sport-management.component";
import {
  BetListComponent,
  BetDetailsModalComponent,
  ProviderStatusModalComponent,
  CommonModalComponent,
  EventMappingModal,
  UserAuditModalComponent,
  UserMarketModalComponent,
  ChangePasswordModalComponent,
  // OperatorModalComponent,
  OperatorEditModalComponent,
  ProviderManagementComponent,
  CompetitionManagementComponent,
  EventManagementComponent,
  MarketManagementComponent,
  MarketRiskComponent,
  EventOpenBetsComponent,
  EventMappingComponent,
  UserAccountComponent,
  UserManagementComponent,
  UserAccDetailsModalComponent,
  OperatorsManagementComponent,
  PartnersManagementComponent,
  EditPartnersModalComponent,
  SettingManagementComponent,
  ArbitrageConfigurationComponent,
  SportArbitrageDecisionsComponent,
  EventArbitrageDecisionsComponent,
  ArbitrageDecisionsDetailComponent,
  ArbitrageDecisionsComponent,
  ArbitrageReportComponent,
  EventArbitrageReportComponent,
  PlacedBetsComponent,
  CreateOperatorsComponent,
  CreateUsersComponent,
  AddPartnerModalComponent,
  UserHistoryComponent,
  LeakLedgerComponent,
  MtsReportingSummaryComponent,
  MtsDayDetailComponent,
  MtsReportGeneratorComponent,
  MtsAccountsComponent,
  MtsRejectionsComponent,
  MtsAccountDetailComponent,
  HoldReportComponent,
  PLStatmentComponent,
  PLSportStatmentComponent,
  PLCompetitionStatmentComponent,
  PLEventStatmentComponent,
  GameReportComponent,
  GrProviderLevelComponent,
  GmRepSportsLevelComponent,
  GmRepComptsLevelComponent,
  GmRepEventsLevelComponent,
  GmRepMarketLevelComponent,
  GmRepUserLevelComponent,
  AdminManagementComponent,
  DepositFundsComponent,
  UserAuditComponent,
  FundStatementComponent,
  UserBookComponent,
  PLMarketStatmentComponent,
  UserPLComponent,
  EventRiskComponent,
  MarketSettlementsComponent,
  SapMetricsComponent,
  CatalogueManagementComponent,
  TestCasesComponent,
  TestCasesResultComponent,
  MappingComponent,
  EditMappingModal,
  DeleteConfDialog,
  CommissionEventMarketsComponent,
  CommissionMarketMarketLevelComponent,
  manageMarketCommissionModal,
  MarketStatusModalComponent,
  EditUserComponent,
  BetsSettlementsComponent,
  EventsSettlementsComponent,
  AlertBetsComponent,
  VoidBetsModalComponent,
  GameAnalysisComponent,
} from "./pages/index";
import { HomeComponent } from "./components/home/home.component";
import {
  LogInComponent,
  TwoFactorComponent,
  UserSeachComponent,
  OperatorSeachComponent,
} from "./components/index";
import { SidenavComponent } from "./components/sidenav/sidenav.component";
import { DahsboardComponent } from "./pages/dahsboard/dahsboard.component";
import { PlaceHolderComponent } from "./components/place-holder/place-holder.component";
import { ColorConfigurationComponent } from "./pages/color-configuration/color-configuration.component";
import { ColorSketchModule } from "ngx-color/sketch";
import { ColorBlockModule } from "ngx-color/block";
import { ColorModalComponent } from "./pages/color-configuration/color-modal/color-modal.component";

import { CommissionMarketsComponent } from "./pages/commission-markets/commission-markets.component";
import { MarketMappingComponent, EditMaxBetsModal } from "./pages/market-mapping/market-mapping.component";
import {
  MarketMappingTableComponent,
  RunnerMappingModal,
} from "./pages/market-mapping-table/market-mapping-table.component";
import { UploadModalComponent } from "./pages/competition-management/competition-management.component";
import {
  AlertModalComponent,
  BetDetailsComponent,
  BetsMonitoringComponent,
} from "./pages/bets-monitoring/bets-monitoring.component";
import { AddMarketComponent } from "./pages/add-market/add-market.component";
import { OperatorUsersComponent } from "./pages/operator-users/operator-users.component";
import { DeleteMarketModalComponent } from "./pages/market-management/market-management.component";
import { OperatorProviderManagementComponent } from "./pages/operator-provider-management/operator-provider-management.component";
import { ProviderMarketsComponent } from "./pages/provider-markets/provider-markets.component";
import { EditMarketComponent } from "./pages/edit-market/edit-market.component";
import { DeleteUserModalComponent ,ChangeUserPasswordComponent } from "./pages/user-management/user-management.component";
import { HoldConfirmModal, SettlementMarketsModal } from "./pages/market-settlements/market-settlements.component";
import { PreviewScreenComponent } from './pages/preview-screen/preview-screen.component';
import { MarketBetsSettlementComponent } from './pages/market-bets-settlement/market-bets-settlement.component';
import { TommyManualComponent, CreateTommyEvent } from './pages/tommy-manual/tommy-manual.component';
import { SrEventsComponent } from './pages/sr-events/sr-events.component';
import { BetRollbackModal,BetSettlementModal, SettlementConfirmModal,SrBetsSettlementComponent } from './pages/sr-bets-settlement/sr-bets-settlement.component';
import { RiskBetsComponent, RiskBetsModalComponent } from "./pages/risk-bets/risk-bets.component";
import { DbCollectionComponent, SampleDocComponent } from './pages/db-collection/db-collection.component';
import { PrettyJsonModule } from "src/_helpers/prettyjson.pipe";
import { PremiumMappingComponent, PremiumModalComponent, PremiumUnmapModalComponent } from "./pages/premium-mapping/premium-mapping.component";
import { GeniePremiumMappingComponent, GenieEventMappingModal, GenieEditMappingModal } from './pages/genie-premium-mapping/genie-premium-mapping.component';
import { OpEventsComponent } from './op-events/op-events.component';
import { OpMarketsComponent } from './op-markets/op-markets.component';
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { OperatorDashboardComponent } from './pages/operator-dashboard/operator-dashboard.component';
import { OpBetsSettleComponent } from './pages/op-bets-settle/op-bets-settle.component';
import { VirtualMetricsComponent } from './pages/virtual-metrics/virtual-metrics.component';
import { SrMarketVoidComponent } from './pages/sr-market-void/sr-market-void.component';
import { B2bOperatorsComponent } from './pages/b2b-operators/b2b-operators.component';
import { InvoiceManagementComponent,CreateOperatorCommission,CloneCommission } from './pages/invoice-management/invoice-management.component';
import { InvoicePrMngtComponent,CreateIframeCommission } from './pages/invoice-pr-mngt/invoice-pr-mngt.component';
import { InvoiceReportComponent,ManualAdjustment, ConfirmDialogComponent,UpdateReportCommission } from './pages/invoice-report/invoice-report.component';
import { CreateRXEvent } from "./pages/catalogue-management/catalogue-management.component";
import { CatalogueEventsComponent } from './pages/catalogue-events/catalogue-events.component';
import { CatalogueMarketsComponent } from './pages/catalogue-markets/catalogue-markets.component';
import { AddRules, CatalogueRulesComponent, DeleteRuleModal } from './pages/catalogue-rules/catalogue-rules.component';
import { AddEditLimit, LimitsManagementComponent } from './pages/limits-management/limits-management.component';
import { AssignUserLimitComponent } from './pages/assign-user-limit/assign-user-limit.component';
import { AddAutoMapConfig, CatalogueAutoMapComponent } from './pages/catalogue-auto-map/catalogue-auto-map.component';
import { ThumbnailModalComponent } from "./pages/event-management/event-management.component";
import { OPUserInfoModalComponent } from "./pages/operators-management/operators/create-operators.component";
import { CrmEventsComponent } from './pages/crm-events/crm-events.component';
import { CRMMappingModal, CrmMarketsComponent, UnmapConfirmationDialog } from './pages/crm-markets/crm-markets.component';
import { TwoFaQrModalComponent } from "./pages/user-management/twofa-qr-modal.component";

@NgModule({
  declarations: [
    AppComponent,
    SportManagementComponent,
    BetListComponent,
    DepositFundsComponent,
    DahsboardComponent,
    LogInComponent,
    TwoFactorComponent,
    SidenavComponent,
    HomeComponent,
    EventRiskComponent,
    PlaceHolderComponent,
    UserAccountComponent,
    UserManagementComponent,
    ProviderManagementComponent,
    OperatorsManagementComponent,
    PartnersManagementComponent,
    CompetitionManagementComponent,
    EventManagementComponent,
    MarketManagementComponent,
    MarketRiskComponent,
    EventOpenBetsComponent,
    EventMappingComponent,
    BetDetailsModalComponent,
    UserBookComponent,
    ProviderStatusModalComponent,
    CommonModalComponent,
    EventMappingModal,
    EditMappingModal,
    DepositFundsComponent,
    UserAuditModalComponent,
    SettlementMarketsModal,
    UserMarketModalComponent,
    BetsSettlementsComponent,
    EventsSettlementsComponent,
    // OperatorModalComponent,
    OperatorEditModalComponent,
    ChangePasswordModalComponent,
    EditPartnersModalComponent,
    AddPartnerModalComponent,
    UserAccDetailsModalComponent,
    SettingManagementComponent,
    ArbitrageConfigurationComponent,
    SportArbitrageDecisionsComponent,
    EventArbitrageDecisionsComponent,
    ArbitrageDecisionsDetailComponent,
    ArbitrageDecisionsComponent,
    ArbitrageReportComponent,
    EventArbitrageReportComponent,
    PlacedBetsComponent,
    CreateOperatorsComponent,
    CreateUsersComponent,
    FundStatementComponent,
    UserHistoryComponent,
    LeakLedgerComponent,
  MtsReportingSummaryComponent,
  MtsDayDetailComponent,
  MtsReportGeneratorComponent,
  MtsAccountsComponent,
  MtsRejectionsComponent,
  MtsAccountDetailComponent,
    HoldReportComponent,
    PLStatmentComponent,
    PLSportStatmentComponent,
    PLCompetitionStatmentComponent,
    PLEventStatmentComponent,
    PLMarketStatmentComponent,
    GameReportComponent,
    GrProviderLevelComponent,
    GmRepSportsLevelComponent,
    GmRepComptsLevelComponent,
    GmRepEventsLevelComponent,
    GmRepMarketLevelComponent,
    GmRepUserLevelComponent,
    AdminManagementComponent,
    UserAuditComponent,
    UserSeachComponent,
    OperatorSeachComponent,
    UserPLComponent,
    SapMetricsComponent,
    MarketSettlementsComponent,
    CatalogueManagementComponent,
    MappingComponent,
    TestCasesComponent,
    TestCasesResultComponent,
    MappingComponent,
    ColorConfigurationComponent,
    ColorModalComponent,
    DeleteConfDialog,
    CommissionMarketsComponent,
    MarketMappingComponent,
    EditMaxBetsModal,
    CommissionEventMarketsComponent,
    CommissionMarketMarketLevelComponent,
    manageMarketCommissionModal,
    MarketMappingTableComponent,
    UploadModalComponent,
    RunnerMappingModal,
    BetsMonitoringComponent,
    BetDetailsComponent,
    AlertModalComponent,
    AddMarketComponent,
    OperatorUsersComponent,
    DeleteMarketModalComponent,
    OperatorProviderManagementComponent,
    ProviderMarketsComponent,
    MarketStatusModalComponent,
    EditMarketComponent,
    EditUserComponent,
    DeleteUserModalComponent,
    ChangeUserPasswordComponent,
    AlertBetsComponent,
    VoidBetsModalComponent,
    GameAnalysisComponent,
    PreviewScreenComponent,
    MarketBetsSettlementComponent,
    TommyManualComponent,
    CreateTommyEvent,
    SrEventsComponent,
    SrBetsSettlementComponent,
    BetRollbackModal,
    RiskBetsComponent,
    RiskBetsModalComponent,
    DbCollectionComponent,
    SampleDocComponent,
    PremiumMappingComponent,
    PremiumModalComponent,
    PremiumUnmapModalComponent,
    GeniePremiumMappingComponent,
    GenieEventMappingModal,
    GenieEditMappingModal,
    OpEventsComponent,
    OpMarketsComponent,
    DashboardComponent,
    OperatorDashboardComponent,
    OpBetsSettleComponent,
    BetSettlementModal,
    SettlementConfirmModal,
    VirtualMetricsComponent,
    SrMarketVoidComponent,
    B2bOperatorsComponent,
    InvoiceManagementComponent,
    CreateOperatorCommission,
    InvoicePrMngtComponent,
    CreateIframeCommission,
    CloneCommission,
    InvoiceReportComponent,
    ManualAdjustment,
    ConfirmDialogComponent,
    UpdateReportCommission,
    CreateRXEvent,
    HoldConfirmModal,
    CatalogueEventsComponent,
    CatalogueMarketsComponent,
    CatalogueRulesComponent,
    AddRules,
    DeleteRuleModal,
    LimitsManagementComponent,
    AddEditLimit,
    AssignUserLimitComponent,
    CatalogueAutoMapComponent,
    AddAutoMapConfig,
    ThumbnailModalComponent,
    OPUserInfoModalComponent,
    CrmEventsComponent,
    CrmMarketsComponent,
    CRMMappingModal,
    UnmapConfirmationDialog,
    TwoFaQrModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    NgMultiSelectDropDownModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatSlideToggleModule,
    MatDialogModule,
    MatNativeDateModule,
    NgxDaterangepickerMd.forRoot(),
    ColorSketchModule,
    ColorBlockModule,
    PrettyJsonModule,
    NgApexchartsModule,
  ],
  entryComponents: [
    AlertModalComponent,
    BetDetailsModalComponent,
    BetDetailsComponent,
    UserAccDetailsModalComponent,
    ProviderStatusModalComponent,
    CommonModalComponent,
    EventMappingModal,
    EditMappingModal,
    GenieEventMappingModal,
    GenieEditMappingModal,
    DeleteConfDialog,
    manageMarketCommissionModal,
    UserAuditModalComponent,
    UserMarketModalComponent,
    EditPartnersModalComponent,
    ChangePasswordModalComponent,
    AddPartnerModalComponent,
    DepositFundsComponent,
    OperatorEditModalComponent,
    UserBookComponent,
    ColorModalComponent,
    SettlementMarketsModal,
    UploadModalComponent,
    RunnerMappingModal,
    EditMaxBetsModal,
    DeleteMarketModalComponent,
    MarketStatusModalComponent,
    DeleteUserModalComponent,
    ChangeUserPasswordComponent,
    VoidBetsModalComponent,
    CreateTommyEvent,
    BetRollbackModal,
    RiskBetsModalComponent,
    SampleDocComponent,
    PremiumModalComponent,
    PremiumUnmapModalComponent,
    BetSettlementModal,
    SettlementConfirmModal,
    CreateOperatorCommission,
    CreateIframeCommission,
    CloneCommission,
    ManualAdjustment,
    ConfirmDialogComponent,
    UpdateReportCommission,
    CreateRXEvent,
    HoldConfirmModal,
    AddRules,
    DeleteRuleModal,
    AddEditLimit,
    AssignUserLimitComponent,
    AddAutoMapConfig,
    ThumbnailModalComponent,
    OPUserInfoModalComponent,
    CRMMappingModal,
    UnmapConfirmationDialog,
    TwoFaQrModalComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },

    // provider used to create fake backend
    // fakeBackendProvider,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
